import React from "react";
import TitleIcon from "@material-ui/icons/Title";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

export const FontSizeButtonGroup = (props) => {
  return (
    <ToggleButtonGroup
      size="small"
      value={props.fontSize}
      exclusive
      onChange={props.handleFontSizeChange}
      aria-label="font size"
    >
      <ToggleButton
        value="0"
        aria-label="small"
        disabled={props.fontSize === "0"}
      >
        <TitleIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton
        value="1"
        aria-label="medium"
        disabled={props.fontSize === "1"}
      >
        <TitleIcon />
      </ToggleButton>
      <ToggleButton
        value="2"
        aria-label="large"
        disabled={props.fontSize === "2"}
      >
        <TitleIcon fontSize="large" />
      </ToggleButton>
      <ToggleButton
        value="3"
        aria-label="extra large"
        disabled={props.fontSize === "3"}
      >
        <TitleIcon style={{ fontSize: 40 }} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
